import AsyncStorage from '@react-native-async-storage/async-storage'
import { useRouter } from 'expo-router'
import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
  ReactNode,
} from 'react'

import { ONBOARDING_DONE } from '@constants/storages'

interface IOnboardingContextData {
  isOnboardingDone: boolean
  isLoading: boolean
  finishOnboarding: () => Promise<void>
}

const OnboardingContext = createContext<IOnboardingContextData>(
  {} as IOnboardingContextData,
)

export function OnboardingProvider({ children }: { children: ReactNode }) {
  const [isOnboardingDone, setIsOnboardingDone] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const router = useRouter()

  useEffect(() => {
    AsyncStorage.getItem(ONBOARDING_DONE)
      .then((value) => {
        setIsOnboardingDone(value === 'true')
      })
      .catch(() => {
        setIsOnboardingDone(false)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const finishOnboarding = useCallback(async () => {
    await AsyncStorage.setItem(ONBOARDING_DONE, 'true')
    setIsOnboardingDone(true)
    router.replace('/users/sign_in')
  }, [router])

  return (
    <OnboardingContext.Provider
      value={{ isOnboardingDone, isLoading, finishOnboarding }}
    >
      {children}
    </OnboardingContext.Provider>
  )
}

export function useOnboarding() {
  const context = useContext(OnboardingContext)
  if (!context) {
    throw new Error(
      'useOnboarding deve ser usado dentro de um OnboardingProvider',
    )
  }
  return context
}
